<script lang="ts">
    import { createEventDispatcher, getContext } from "svelte";
    import type { Supabase } from "./structure";

    let email: string;
    let password: string;
    const supabase: Supabase = getContext("supabase");
    const user: any = getContext("user");

    let disabled = false;
    const login = async () => {
        disabled = true;
        const { data, error } = await $supabase
            .from("users")
            .select("*")
            .ilike("email", email)
            .eq("password", password);
        console.log(data, error);
        if (data.length !== 0) {
            const tempUser = data[0];
            localStorage.setItem("gambler", JSON.stringify(tempUser));
            $user = tempUser;
            return;
        }
        // invalid email or password
        disabled = false;
    };
</script>

<div class="space-y-4 text-center">
    <h1
        class="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl/none"
    >
        Sign in to continue!
    </h1>
</div>
<div class="max-w-sm space-y-4 mt-4">
    <div class="flex flex-col space-y-2">
        <input
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            placeholder="Enter your email"
            type="email"
            bind:value={email}
        /><input
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
            placeholder="Enter your password"
            type="password"
            bind:value={password}
        /><button
            on:click={login}
            {disabled}
            class="inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 w-full"
            >Login</button
        >
    </div>

    <div class="text-sm text-center">
        <span class=""
            >Don't have an account? <button
                on:click
                class="text-blue-600 font-semibold">Register</button
            ></span
        >
    </div>
</div>
